const API_ADMIN = process.env.VUE_APP_API_ADMIN_LOCATION;

export default {
  fetchB2BAssessmentPackageAssignment(language) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`${API_ADMIN}b2b-assessment-package-assignments`, {
          headers: {
            'Accept-Language': language,
            ignoreLoading: true,
          },
        })
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch(reject);
    });
  },

  createB2BAssessmentPackageAssignment(payload) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}b2b-assessment-package-assignments`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  updateB2BAssessmentPackageAssignment(id, payload) {
    return new Promise((resolve, reject) => {
      window.axios
        .patch(`${API_ADMIN}b2b-assessment-package-assignments/${id}`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  deleteB2BAssessmentPackageAssignment(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}b2b-assessment-package-assignments/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
};
